import { render } from "./EditUserModal.vue?vue&type=template&id=5a489deb&ts=true"
import script from "./EditUserModal.vue?vue&type=script&lang=ts"
export * from "./EditUserModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
